import { Dispatch, SetStateAction } from 'react'
import { CurrentAuth, User } from '../Data/UserInterface'

export interface AuthContextProps {
  initializing: boolean
  currentAuth: CurrentAuth | null
  setCurrentAuth: Dispatch<SetStateAction<CurrentAuth | null>>
  currentUser: User | null
  setCurrentUser: Dispatch<SetStateAction<User | null>>
  onboarding: boolean
  setOnboarding: Dispatch<SetStateAction<boolean>>
  queryParams: URLSearchParams | null
  setQueryParams: Dispatch<SetStateAction<URLSearchParams | null>>
  newUser: User | null
  setNewUser: Dispatch<SetStateAction<User | null>>
}

export const AuthContextDefaultValues: AuthContextProps = {
  initializing: true,
  currentAuth: null,
  setCurrentAuth: () => null,
  currentUser: null,
  setCurrentUser: () => null,
  onboarding: false,
  setOnboarding: () => {},
  queryParams: null,
  setQueryParams: () => {},
  newUser: null,
  setNewUser: () => null,
}
